import {TaskRequest} from './task-request';

export class BuyerAppointmentBulkRequest {
  buyerId: number;
  prospectIds: number[];
  task: TaskRequest;
}
